import { Link, useNavigate } from 'react-router-dom';

import { LogoutIcon } from 'assets';
import { LogoSmallIcon } from 'assets';

import { logout } from 'entities/Auth/sdk';

import IconButton from 'components/IconButton';
import NavigationTab from 'components/SideNavigation/NavigationTab';

import { removeToken } from 'utils/storage';

import { URLS } from 'config/urls';

const SideNavigation = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    return logout().then(() => {
      removeToken();
      navigate(URLS.LOGIN);
    });
  };

  return (
    <nav
      className={`fixed top-0 left-0 flex h-screen w-40 flex-col bg-indigo-950 px-2 py-5`}
    >
      <div className="flex flex-1 flex-col items-center justify-between">
        <div className="flex w-full flex-col items-center gap-y-2">
          <LogoSmallIcon />
          <NavigationTab to={URLS.HOME}>
            <div>Home</div>
          </NavigationTab>
          <div className="p-5">
            <NavigationTab to={URLS.ABOUT}>
              <div>Student Work Repository</div>
            </NavigationTab>
          </div>
          <NavigationTab to={URLS.CHARTS}>
            <div>Analysis</div>
          </NavigationTab>
        </div>
        <div className="flex flex-col items-center gap-4 px-3 text-sm leading-[0] text-white">
          <IconButton
            onClick={handleLogout}
            aria-label="logout"
            classes={{ root: 'py-0' }}
          >
            <LogoutIcon />
          </IconButton>
          <Link
            to="https://docs.google.com/document/d/1SzbHQJ38lOQAifFMKg2SITZOtyNs0KZ0pQvC5HKDfJ8/edit?tab=t.0#heading=h.yiazd6mkmzyx"
            target="_blank"
          >
            Terms of Use
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default SideNavigation;
